import { trackPubAvailPopupAction } from '../../segments/pub-avail/PubAvail.tracking';

export default ['$scope', 'pubAvailService', 'analyticsService', function($scope, pubAvailService, analyticsService) {
  this.pubAvailService = pubAvailService;
  $scope.$on('modal.closing', (event, result, closed) => {
    // only on dismiss
    if (!closed) {
      trackPubAvailPopupAction(pubAvailService.pubAvailData.windowModeType, 'Close');
    }
  });
}];
